var map = {
	"./de": 42613,
	"./de.json": 42613,
	"./en": 5977,
	"./en.json": 5977,
	"./es": 81290,
	"./es.json": 81290,
	"./fr": 53762,
	"./fr.json": 53762,
	"./nl": 12060,
	"./nl.json": 12060,
	"./nl_gsv": 41391,
	"./nl_gsv.json": 41391,
	"./nl_sportkompas": 75462,
	"./nl_sportkompas.json": 75462,
	"./nl_vitale": 62008,
	"./nl_vitale.json": 62008,
	"./pt": 87606,
	"./pt.json": 87606
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18077;